import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import {
  Drawer,
  IconButton,
  Box,
  useMediaQuery
} from "@mui/material";
import Swal from 'sweetalert2';
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

/* 🔹 menulist */
import { getMenuListByUserType, filterMenuByLoginAccess, getStoredLoginMenus } from "utils/menuConfig";
import logo from 'assets/images/logoside.png';
import { useNavigate, useLocation } from 'react-router-dom';
const SIDEBAR_WIDTH = 250;

/* ================= SIDEBAR CONTENT ================= */
const SidebarContent = ({ isMobile, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
    const currentPath = location.pathname;
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const filteredMenuList = filterMenuByLoginAccess(
    getMenuListByUserType(user?.userTypeId, user?.userCode),
    getStoredLoginMenus()
  );
     const distibutor = JSON.parse(localStorage.getItem('distributor'));
  const retailerName = JSON.parse(localStorage.getItem('retailerName'));
 // const fromritrival = JSON.parse(localStorage.getItem('fromritrival'));
  const fromedit = localStorage.getItem('fromedit');
 // const fromreplicate = localStorage.getItem('fromreplicate');
  const [openSections, setOpenSections] = useState(() => {
    const obj = {};
    filteredMenuList.forEach(sec => (obj[sec.title] = true));
    return obj;
  });
    const theme = useTheme();

  const toggleSection = (title) => {
    setOpenSections(prev => ({
      ...prev,
      [title]: !prev[title]
    }));
  };

  const hideOnPendingOrder = currentPath.includes('pending-order-reports') 
  || currentPath.includes('outstanding-reports')|| currentPath.includes('collection-recieved')
  || currentPath.includes('collection-target-achv-report');

  const handleMenuToggle = (nextPath) => {
    if (currentPath !== '/report-dashboard') {

      if (
        currentPath.includes('productBookingg') ||
        currentPath.includes('productBookingf')
      ) {
        showExitAlert(nextPath);
        return;
      }

      if (nextPath.includes('salesorder')) {
        localStorage.setItem('SelectedCustomer', null);
      }

      if (hideOnPendingOrder) {
        navigate('/report-dashboard', { replace: true });
        return;
      }
    }

    // ✅ finally go to clicked menu
    navigate(nextPath);
  };

  const showExitAlert = async (nextPath) => {
      const swalResult = await Swal.fire({
        title: 'Siyaram',
        text: 'Do you want to continue without saving current grid value ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'swal-confirm-button',
          cancelButton: 'swal-cancel-button',
          actions: 'swal-buttons-container'
        },
        buttonsStyling: false
      });
  
      // Check the result to determine which button was clicked
      if (swalResult.isConfirmed) {
        // console.log('User clicked "Okay"');
        localStorage.setItem('orderupdatedList', null);
        localStorage.setItem('ordernumber', '');
        localStorage.setItem('materialListupdate', null);
        //localStorage.setItem("materialList",null);
        localStorage.setItem('sizexOriginalQty', null);
        // console.log("fromritrival===>"+fromritrival);
  
        if ((distibutor == 'undefined' || distibutor == null) && (retailerName == 'undefined' || retailerName == null) && fromedit !== '1') {
          navigate(-1, { replace: true });
        }else{
          navigate(nextPath, { replace: true });
        }
        // else if (fromritrival === 1) {
        //   navigate(-2, { replace: true });
        // } else if (fromreplicate === '1') {
        //   navigate(-1, { replace: true });
        // } else {
        //   navigate(nextPath, { replace: true });
        // }
      } else if (swalResult.isDismissed) {
        // console.log('User clicked "Cancel" or closed the dialogue');
        // Perform actions for "Cancel" button or closing the dialogue
      }
    };

  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
    height: "100vh",
    bgcolor: "#0F172A",
    color: "#E5E7EB",
    overflowY: "auto",

    /* 🔹 Hide scrollbar but allow scroll */
    scrollbarWidth: "none",          // Firefox
    "&::-webkit-scrollbar": {
      display: "none"               // Chrome, Edge, Safari
    }
      }}
    >
      {/* HEADER */}
      <Box
  sx={{
    minHeight: '67px',
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
    position: 'sticky',   // 👈 sticky
    top: 0,               // 👈 upar fix
    zIndex: 10,
    backgroundColor: "#0F172A"  // same as sidebar
  }}
>
  <img
    src={logo}
    alt="Siyaram"
    width="100%"
    height={65}
    style={{ objectFit: 'contain' }}
  />

  {isMobile && (
    <IconButton onClick={onClose} sx={{ color: "#fff" }}>
      <CloseIcon />
    </IconButton>
  )}
</Box>


      {/* MENU */}
      {filteredMenuList.map((section, index) => (
        <Box key={section.title} sx={{ px: 1, mt: index === 0 ? 3 : 0 }}>
          {/* SECTION HEADER */}
          <Box
            onClick={() => toggleSection(section.title)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1.5,
              py: 1,
              cursor: "pointer",
              color: "#94A3B8",
              textTransform: "uppercase",
              fontSize: 13,
              "&:hover": { color: "#fff" }
            }}
          >
            {section.title}
            {openSections[section.title]
              ? <ExpandLessIcon fontSize="small" />
              : <ExpandMoreIcon fontSize="small" />
            }
          </Box>

          {/* ITEMS */}
          {openSections[section.title] &&
            section.subItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.nav}
                 onClick={(e) => {
                  e.preventDefault();                 // stop default NavLink navigation
                  handleMenuToggle(item.nav);         // 👈 your logic
                  if (isMobile && onClose) onClose(); // close drawer on mobile
                }}
                style={({ isActive }) => ({
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "8px 12px",
                  marginBottom: 4,
                  borderRadius: 8,
                  fontSize: 14,
                  textDecoration: "none",
                  color: isActive ? "red" : "#CBD5E1",
                  background: isActive ? "#1E293B" : "transparent"
                })}
              >
                {item.image && (
                  <img
                    src={item.image}
                    alt=""
                    width={18}
                    height={18}
                    style={{ objectFit: "contain" }}
                  />
                )}
                {item.name}
              </NavLink>
            ))}
        </Box>
      ))}
    </Box>
  );
};

/* ================= MAIN COMPONENT ================= */
const ReportsSidebar = ({ open, setOpen}) => {
  const isMobile = useMediaQuery("(max-width:900px)");

  /* ---------- MOBILE ---------- */
  if (isMobile) {
    return (
      <>
        {!open && (
          <IconButton
            onClick={() => {
    setOpen(true);
  }}
            sx={{
              position: "fixed",
              top: 16,
              left: 16,
              zIndex: 1300,
              bgcolor: "#0F172A",
              color: "#fff",
              "&:hover": { bgcolor: "#020617" }
            }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Drawer
          open={open}
          onClose={() => setOpen(false)}
          PaperProps={{ sx: { width: SIDEBAR_WIDTH } }}
        >
          <SidebarContent isMobile onClose={() => setOpen(false)} />
        </Drawer>
      </>
    );
  }

  /* ---------- DESKTOP ---------- */
  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        position: "fixed",
        left: 0,
        top: 0,
        height: "100vh"
      }}
    >
      <SidebarContent />
    </Box>
  );
};

export default ReportsSidebar;
